import { render } from "./WithBackgroundOverlay.vue?vue&type=template&id=ee8e2c5a"
import script from "./WithBackgroundOverlay.vue?vue&type=script&lang=js"
export * from "./WithBackgroundOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__